<div [ngClass]="{ 'profile-wrapper': !isMobile, 'profile-mobile-wrapper': isMobile }">

  <!-- Mobile breadcrumb -->
  <div class="mobile-breadcrumb" *ngIf="isMobile && isCompanyProfilePage()">
    <button class="back-btn" (click)="goBacktoHome()">
      <i class="bi bi-chevron-left" *ngIf="userLang=='en'"></i>
      <i class="bi bi-chevron-right" *ngIf="userLang=='ar'"></i>
    </button>
    <div class="breadcrumb-text">
      <span class="breadcrumb-home" (click)="goBackToDashboard()">
        {{ 'companyAdmin.title' | translate }}
      </span>
    </div>
  </div>

  <!-- Mobile page head (for sub-pages) -->
  <div class="page-head" *ngIf="!isCompanyProfilePage() && isMobile">
    <div class="breadcrumb-text">
      <span class="breadcrumb-home" (click)="goBackToDashboard()">
        {{ 'companyAdmin.title' | translate }}
      </span>
      <i class="bi bi-slash-lg"></i>
      <span class="breadcrumb-current">{{ getCurrentPageTitle() | translate }}</span>
    </div>
  </div>

  <div class="profile-card">
    <div class="card-body">

      <!-- Desktop Sidebar -->
      <div class="sidebar" *ngIf="!isMobile">
        <ul>
          <li routerLink="company-profile" routerLinkActive="active">
            <i class="bi bi-building"></i> {{ 'companyAdmin.companyProfile' | translate }}
          </li>
          <!-- <li routerLink="positions" routerLinkActive="active">
            <i class="bi bi-diagram-3"></i> {{ 'companyAdmin.positions' | translate }}
          </li> -->
          <li routerLink="job-posts" routerLinkActive="active">
            <i class="bi bi-file-earmark-text"></i> {{ 'companyAdmin.jobPosts' | translate }}
          </li>
          <li routerLink="comapny-reviews" routerLinkActive="active">
            <i class="bi bi-file-earmark-text"></i> {{ 'companyAdmin.reviews' | translate }}
          </li>

          <li routerLink="all-applications" routerLinkActive="active">
            <i class="bi bi-people"></i> {{ 'companyAdmin.allApplications' | translate }}
          </li>
          <li routerLink="virtual-interviews" routerLinkActive="active">
            <i class="bi bi-camera-video"></i> {{ 'companyAdmin.virtualInterviews' | translate }}
          </li>
          <li routerLink="billing-payments" routerLinkActive="active">
            <i class="bi bi-credit-card"></i> {{ 'companyAdmin.billingPayments' | translate }}
          </li>

        </ul>

        <div class="bottom mt-5">
          <a (click)="openLogoutModal()" class="logut">
            <i class="bi bi-box-arrow-right"></i>
            <span class="ms-2">{{ 'profile.logout' | translate }}</span>
          </a>
          <a (click)="openDeleteModal()" class="danger">
            <i class="bi bi-trash"></i>
            <span class="ms-2">{{ 'profile.deleteAccount' | translate }}</span>
          </a>
        </div>
      </div>

      <!-- Mobile Tabs -->
      <div class="mobile-tabs" *ngIf="isCompanyProfilePage() && isMobile">
        <button class="tab-button" [class.active]="activeTab === 'profile'" (click)="setActiveTab('profile')"
          routerLink="company-profile">
          <i class="bi bi-building"></i>
          {{ 'companyAdmin.companyProfile' | translate }}
        </button>
        <button class="tab-button" [class.active]="activeTab === 'services'" (click)="setActiveTab('services')">
          <i class="bi bi-grid"></i>
          {{ 'profile.services' | translate }}
        </button>
      </div>

      <!-- Mobile Services Dropdown -->
      <div class="services-dropdown" *ngIf="isMobile && showServicesDropdown && isCompanyProfilePage()">
        <ul>
          <!-- <li routerLink="positions" (click)="closeDropdown()">
            <i class="bi bi-diagram-3"></i> {{ 'companyAdmin.positions' | translate }}
          </li> -->
          <li routerLink="job-posts" (click)="closeDropdown()">
            <i class="bi bi-file-earmark-text"></i> {{ 'companyAdmin.jobPosts' | translate }}
          </li>
          <li routerLink="job-applications" (click)="closeDropdown()">
            <i class="bi bi-person-lines-fill"></i> {{ 'companyAdmin.jobApplications' | translate }}
          </li>
          <li routerLink="virtual-interviews" (click)="closeDropdown()">
            <i class="bi bi-camera-video"></i> {{ 'companyAdmin.virtualInterviews' | translate }}
          </li>
          <li routerLink="billing-payments" (click)="closeDropdown()">
            <i class="bi bi-credit-card"></i> {{ 'companyAdmin.billingPayments' | translate }}
          </li>

        </ul>
        <div class="bottom mt-5">
          <a (click)="openLogoutModal()" class="logut">
            <i class="bi bi-box-arrow-right"></i>
            <span class="ms-2">{{ 'profile.logout' | translate }}</span>
          </a>
          <a (click)="openDeleteModal()" class="danger">
            <i class="bi bi-trash"></i>
            <span class="ms-2">{{ 'profile.deleteAccount' | translate }}</span>
          </a>
        </div>
      </div>

      <!-- Logout Modal -->
      <div class="custom-modal" *ngIf="showLogoutModal">
        <div class="modal-content">
          <button class="close-btn" (click)="closeLogoutModal()">×</button>
          <h2>{{ 'profile.logoutConfirmTitle' | translate }}</h2>
          <p>{{ 'profile.logoutConfirmDesc' | translate }}</p>
          <div class="modal-actions">
            <button class="btn-logout" (click)="confirmLogout()">{{ 'profile.logout' | translate }}</button>
            <button class="btn-cancel" (click)="closeLogoutModal()">{{ 'common.cancel' | translate }}</button>
          </div>
        </div>
      </div>

      <!-- Delete Account Modal -->
      <div class="custom-modal" *ngIf="showDeleteModal">
        <div class="modal-content">
          <button class="close-btn" (click)="closeDeleteModal()">×</button>
          <h2>{{ 'profile.deleteConfirmTitle' | translate }}</h2>
          <p>{{ 'profile.deleteConfirmDesc' | translate }}</p>
          <div class="modal-actions">
            <button class="btn-logout" (click)="deleteUserAccount()">{{ 'profile.deleteAccount' | translate }}</button>
            <button class="btn-cancel" (click)="closeDeleteModal()">{{ 'common.cancel' | translate }}</button>
          </div>
        </div>
      </div>

      <div class="divider"></div>
      <div class="content" *ngIf="!showServicesDropdown">
        <router-outlet></router-outlet>
      </div>

    </div>
  </div>
</div>
